<mat-form-field class="w-100" appearance="outline">
  <input
    matInput
    placeholder="تاریخ انقضاء"
    [matDatepicker]="picker"
    [value]="expirationDate"
    (focus)="picker.open()"
    (dateChange)="emitExpirationDate($event)"
  />
  <mat-datepicker-toggle matSuffix [for]="picker">
    <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
  </mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
